
import { Options, Vue } from "vue-class-component";
// component imports
import EmailForm from "@/components/EmailForm.vue";
// plugins
import axios from "axios";
// firebase
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  collection,
  query,
  onSnapshot,
  getDocs,
} from "firebase/firestore";
import { db } from "@/firebase";

// plugins
import emailjs from "@emailjs/browser";
emailjs.init("user_tJQeT8oPh8t2hKaVxbHoR");

@Options({
  components: { EmailForm },
})
export default class Home extends Vue {

  public contacts: Record<any, any> = [];
  public currentPosts: Record<any, any> = [];
  public currentProjects: Record<any, any> = [];
  public currentServices: Record<any, any> = [];

  // email form
  public showMessageWindow = false;
  public newMessage: string = "";
  public userId: any = String();

  // website intake forms
  websiteForms: Record<any, any> = [];
  websiteFormIDs: Record<any, any> = [];

  // social media intake forms
  socialMediaForms: Record<any, any> = [];
  socialMediaFormIDs: Record<any, any> = [];

  // app development forms
  appDevForms: Record<any, any> = [];
  appDevFormIDs: Record<any, any> = [];

  // website contact form submissions
  all_emails: Record<any, any> = [];
  all_email_ids: Record<any, any> = [];

  beforeMount() {
    const auth = getAuth();

    onAuthStateChanged(auth, (user) => {
      if (user) {
        getDocs(collection(db, "form_emails", "oG7alUGMl8eBI5zEiSieDnoruEU2", "website_contact_form")).then(
          (QuerySnapshot) => {
            QuerySnapshot.forEach((doc) => {
              this.all_emails.push(doc.data());
              this.all_email_ids.push(doc.id);
            });
          }
        ).then(() => {
          getDocs(collection(db, "/form_data" + "/website_design" + "/submitted_forms")).then((QuerySnapshot) => {
            QuerySnapshot.forEach((doc) => {
              this.websiteForms.push(doc.data());
              this.websiteFormIDs.push(doc.id);
            })
          }).then(() => {
            getDocs(collection(db, "/form_data" + "/social_media" + "/submitted_forms")).then((QuerySnapshot) => {
              QuerySnapshot.forEach((doc) => {
                this.socialMediaForms.push(doc.data());
                this.socialMediaFormIDs.push(doc.id);
              })
            }).then(() => {
              getDocs(collection(db, "/form_data" + "/app_development" + "/submitted_forms")).then((QuerySnapshot) => {
                QuerySnapshot.forEach((doc) => {
                  this.appDevForms.push(doc.data());
                  this.appDevFormIDs.push(doc.id);
                })
              })
            })
          })
        })
      }
    });

    this.getContactData();
  }

  contactPotentialClient(contact: any) {
    window.location.href = 'mailto:' + contact.email;
  }

  getContactData() {
    onSnapshot(query(collection(db, "posts")), (querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.currentPosts.push(doc.data());
      });
    });

    onSnapshot(query(collection(db, "projects")), (querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.currentProjects.push(doc.data());
      });
    });

    onSnapshot(query(collection(db, "services")), (querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.currentServices.push(doc.data());
      });
    });

    axios
      .get(
        "https://api.emailjs.com/api/v1.1/history?user_id=user_tJQeT8oPh8t2hKaVxbHoR&accessToken=52e45eb577794896dea50a88d8ea5a46&template_id=template_qaiorqr"
      )
      .then((res) => {
        const data = res.data.rows.slice(0, 3);
        for (let contact in data) {
          let email_start: any =
            data[contact].template_params.search('"email":"') + 9;
          let email_end: any =
            data[contact].template_params.search('","name":');
          let email_data: any = data[contact].template_params.slice(
            email_start,
            email_end
          );
          let name_start: any =
            data[contact].template_params.search('","name":') + 10;
          let name_end: any =
            data[contact].template_params.search('","message":');
          let name_data: any = data[contact].template_params.slice(
            name_start,
            name_end
          );
          let contact_info = { name: name_data, email: email_data };
          this.contacts.push(contact_info);
        }
      });
  }
}
